module.exports = __webpack_public_path__ + "assets/img/ctg_arw.8f54b97b.svg";